import React, { useState } from 'react';
import { Alert, Button, Card, Col, Form, Image } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ParticlesAuth from './ParticlesAuth';
import api from '../../services/api';
import emailImage from '../../assets/images/auth/email.png';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);

    try {
      const response = await api.post('/forgot-password', { email });
      
      if (response.data && response.data.status === 'success') {
        setSuccess(response.data.message || 'Password reset link has been sent to your email address.');
        setEmail('');
      }
    } catch (err) {
      const errorData = err.response?.data;
      
      if (errorData) {
        // Handle validation errors
        if (errorData.errors && errorData.errors.email) {
          setError(errorData.errors.email[0] || 'Invalid email address.');
        } else if (errorData.message) {
          setError(errorData.message);
        } else {
          setError('Failed to send reset link. Please check your email and try again.');
        }
      } else {
        setError('Failed to send reset link. Please check your email and try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <ParticlesAuth>
      <Col xxl={6} className="mx-auto">
        <Card className="mb-0 border-0 shadow-none mb-0">
          <Card.Body className="p-sm-5 m-lg-4">
            <div className="text-center mt-2">
              <h5 className="fs-3xl">Forgot Password?</h5>
              <p className="text-muted mb-4">Reset password with Volksign</p>
              <div className="pb-4">
                <Image src={emailImage} alt="" className="avatar-md" />
              </div>
            </div>

            <Alert variant="warning" className="text-center mb-2 mx-2 border-0 alert-warning">
              Enter your email and instructions will be sent to you!
            </Alert>

            <div className="p-2">
              {error && (
                <Alert variant="danger" className="mb-3">
                  {error}
                </Alert>
              )}
              {success && (
                <Alert variant="success" className="mb-3">
                  {success}
                </Alert>
              )}

              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-4">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    className="form-control bg-light border-light"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </Form.Group>

                <div className="text-center mt-4">
                  <Button 
                    className="btn btn-primary w-100" 
                    type="submit"
                    disabled={loading}
                  >
                    {loading ? 'Sending...' : 'Send Reset Link'}
                  </Button>
                </div>
              </Form>
            </div>

            <div className="mt-4 text-center">
              <p className="mb-0">
                Wait, I remember my password...{' '}
                <Link to="/login" className="fw-semibold text-primary text-decoration-underline">
                  Click here
                </Link>
              </p>
            </div>
          </Card.Body>
        </Card>
      </Col>
    </ParticlesAuth>
  );
};

export default ForgotPassword;

